import { render } from "./DataPendaftaranView.vue?vue&type=template&id=d4892982&scoped=true"
import script from "./DataPendaftaranView.vue?vue&type=script&lang=js"
export * from "./DataPendaftaranView.vue?vue&type=script&lang=js"

import "./DataPendaftaranView.vue?vue&type=style&index=0&id=d4892982&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4892982"]])

export default __exports__